import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyProvider } from "@/context/CompanyContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Bookings from "@/pages/Bookings";
import BookingForm from "@/pages/BookingForm";
import Payments from "@/pages/Payments";
import Reports from "@/pages/Reports";
import CalendarView from "@/pages/CalendarView";
import MonthlyReport from "@/pages/MonthlyReport";
import Tasks from "@/pages/Tasks";

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return null;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  const role = (user?.role || "ADMIN").toUpperCase();
  if (role !== "ADMIN") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CompanyProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="bookings" element={<Bookings />} />
                <Route path="bookings/new" element={<AdminRoute><BookingForm /></AdminRoute>} />
                <Route path="bookings/:id" element={<BookingForm />} />
                <Route path="calendar" element={<CalendarView />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="payments" element={<Payments />} />
                <Route path="reports" element={<AdminRoute><Reports /></AdminRoute>} />
                <Route path="monthly-report" element={<MonthlyReport />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CompanyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
